
import { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
// import { Mail } from "lucide-react";
import Email from '@mui/icons-material/Email';
// import Imagefile from '../../../assets/images/login.png';
import { AuthContext } from "provider/AuthProvider";
import { constants } from "lib/utilities/Auth";
import { z } from "zod";
import  CircleMatrix  from "examples/CircleMatrix" 

function ForgotPassword({ techyrrAdmin = false }) {
  const [email, setEmail] = useState({
    address: "",
    sending: false,
    sent: false,
    error: false,
    errorCode: "",
  });
  const { resetpassword } = useContext(AuthContext);
  const { errorCodes } = constants;
  const navigate = useNavigate();
  const { origin } = useParams();

  const onChange = (e) => {
    setEmail({ ...email, address: e.target.value });
  };

  const resetPasswordSchema = z.object({
    email: z.string().email(),
  });

  const handleResetPassword = () => {
    const validationResult = resetPasswordSchema.safeParse({ email: email.address });
    if (validationResult.success) {
      setEmail((prev) => ({ ...prev, sending: true }));
      resetpassword(email.address, setEmail).catch((error) => {
        toast.error(
          <p style={{ fontSize: "16px" }}>
            {errorCodes.firebase[error.code] || error.errorInfo?.message || "Try Again"}
          </p>
        );
        setEmail((prev) => ({ ...prev, sending: false }));
      });
    } else {
      toast.error(
        <p style={{ fontSize: "16px" }}>
          {validationResult.error.errors[0].message || "Try Again"}
        </p>
      );
    }
  };

  const handleGotoSignIn = () => {
    if (origin) navigate(`/signin/${origin}`);
    else if (techyrrAdmin) navigate(`/techyrr/signin`);
    else navigate(`/signin`);
  };

  return (
    <div className="flex h-screen w-full">
      {/* Left Side - Form */}
      <div className="flex w-full items-center justify-center bg-white md:w-2/5">
        <div className="w-full max-w-md rounded-2xl bg-white p-8">
          <h1 className="mb-2 text-center text-3xl font-semibold text-gray-900">Forgot your password?</h1>
          <p className="mb-6 text-center text-lg text-gray-500">
            Enter your email address and we'll send you a reset link
          </p>

          {!email.sent ? (
            <div className="space-y-4">
              <TextInput
                icon={<Email />} placeholder="Email"
                name="email" type="email"
                value={email.address} onChange={onChange}
              />
              <button
                onClick={handleResetPassword}
                disabled={email.sending}
                className="w-full rounded-xl bg-black py-2.5 text-lg font-medium text-white transition-colors hover:bg-gray-900"
              >
                {email.sending ? "Sending Email..." : "Send Email"}
              </button>
            </div>
          ) : (
            <p className="text-center text-lg text-gray-700">
              An email has been sent to {email.address} with further instructions.
            </p>
          )}

          <p className="mt-8 text-center text-base text-gray-500">
            <span onClick={handleGotoSignIn} className="cursor-pointer font-medium text-black underline">
              ← Back to Sign In
            </span>
          </p>
        </div>
      </div>

      {/* Right Side - Image */}
      <div className="relative hidden md:block md:w-3/5">
          <CircleMatrix />
      </div>
    </div>
  );
}

function TextInput({ icon, ...props }) {
  return (
    <div className="relative">
      <input
        {...props}
        className="w-full rounded-xl bg-gray-100 px-10 py-3.5 text-lg outline-none placeholder-gray-500 border-none"
      />
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">{icon}</span>
    </div>
  );
}

export default ForgotPassword;
